// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_4r-2";
export var blackBorderOnHover = "_4r-7";
export var cell = "_4r-6";
export var cellContainer = "_4r-3";
export var checked = "_4r-8";
export var disabled = "_4r-5";
export var featuredIconCellContainer = "_4r-9";
export var featuredIconTextContainer = "_4r-b";
export var featuredIconWrapper = "_4r-a";
export var noBorder = "_4r-c";
export var orangeSelectedRow = "_ci-3";
export var overflowableText = "_4r-0";
export var overflowableTextContainer = "_4r-1";
export var row = "_4t-0";
export var rowCheckboxCell = "_4r-4";
export var selectableTable = "_ci-2";